import { FC, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import DOMPurify from 'dompurify';

import 'react-quill/dist/quill.snow.css';
import styles from './TextEditor.module.scss';
import { formats, modules } from './constants';
import { ITextEditorValue } from './types';

interface ITextEditorProps {
  value: string;
  placeholder: string;
  onChange: (value: ITextEditorValue) => void;
}

const TextEditor: FC<ITextEditorProps> = ({ value, placeholder, onChange }) => {
  const quillRef = useRef<ReactQuill | null>(null);

  const handleChange = (content: string) => {
    const text =
      quillRef.current
        ?.getEditor()
        ?.getText()
        .replace(/\u00a0/g, ' ')
        .trim() ?? '';

    const textHtml = DOMPurify.sanitize(content);

    onChange?.({
      text,
      textHtml,
    });
  };

  useEffect(() => {
    handleChange(value);
  }, [value]);

  return (
    <div className={styles.textEditor}>
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

export default TextEditor;
